import leasingItems from './../static-data/leasing-items.json';

export let getMinimumMonths = selectedProducts => {
    let searchedMinimumServer = window.AppConfig && window.AppConfig.minMonths ? window.AppConfig.minMonths : 12;

    let searchedMinimum = 1000;
    let amor = 1000;
    selectedProducts.map( async item => {
        leasingItems.map( el => {
            if ( item.type == el.nazwa ) {
                searchedMinimum = ( parseFloat(el.amortyzacja) < amor ? el.okres : searchedMinimum ).toString()
                amor = ( parseFloat(el.amortyzacja) < amor ? el.amortyzacja : amor )
            }
        })
    })

    if ( parseInt(searchedMinimum) < searchedMinimumServer ) {
        searchedMinimum = searchedMinimumServer
    }
    if ( searchedMinimum == 1000 ) {
        searchedMinimum = window.AppConfig && window.AppConfig.minMonths ? window.AppConfig.minMonths : 12
    }
    return searchedMinimum.toString();
}